__turbopack_context__.v({
  "backButton": "section-header-module-scss-module__H3N7jq__backButton",
  "backButtonWrap": "section-header-module-scss-module__H3N7jq__backButtonWrap",
  "backIcon": "section-header-module-scss-module__H3N7jq__backIcon",
  "leftGroup": "section-header-module-scss-module__H3N7jq__leftGroup",
  "navButton": "section-header-module-scss-module__H3N7jq__navButton",
  "navGroup": "section-header-module-scss-module__H3N7jq__navGroup",
  "navIcon": "section-header-module-scss-module__H3N7jq__navIcon",
  "root": "section-header-module-scss-module__H3N7jq__root",
  "title": "section-header-module-scss-module__H3N7jq__title",
});
